<!-- <template>
  <div class="box">
    <div class="title">
      海宏集团石梁河水库视频监控系统建设项目中标结果公示
    </div>
    <div class="title_box">
      <p class="title_text">根据工程招标投标的有关法律、法规、规章和该工程招标文件的规定，海宏集团石梁河水库视频监控系统建设项目中标人已经确定。现将中标结果公示如下：</p>
      <div class="title_text">
        <span>中标人：</span>
        中国电信股份有限公司连云港分公司
      </div>
      <div class="title_text">
        <span>中标金额：</span>
        4150000元
      </div>
      <div class="title_text">
        <span>质量标准：</span>
        合格
      </div>
      <div class="title_text">
        <span>工期：</span>
        自中标通知书发之日后到项目试运行为60日历天
      </div>
    </div>
    <div class="bottom-box">
      <div class="bottom-box-left">
          <img src="../assets/imgs/建筑.png" alt="">
      </div>
      <div class="bottom-box-right">
            <p class="bottom-box-right-text">
              关于我们 | 网站地图 | 网站声明 <br />
              联系电话：19901541926 (曹经理 微信同号) <br />
              电子邮箱：jingzhaoyin@mail.chinamso.com <br />
              联系地址：中国江苏自由贸易试验区（连云港片区）黄海大道58号  <br />
            </p>
            <div class="bottom-box-right-text1">
              <img src="../assets/imgs/公众号 拷贝.png" alt="">
              <p>微信公众号</p>
            </div>
          <p class="bottom-box-right-text2">Copyright © 2022-2024 江苏海宏智能科技有限公司 版权所有 &nbsp;<span style="cursor: pointer;" @click="jump_gxb">备案号：苏ICP备2021012348号-2</span></p>
      </div>
    </div>
    <div class="back-top">
        <el-button>
          <img src="../assets/imgs/侧边栏/微信.png" alt="">
          <p>微信</p>
        </el-button>
        <el-button>
          <img src="../assets/imgs/侧边栏/形状.png" alt="">
          <p>在线沟通</p>
        </el-button>
        <el-button>
          <img src="../assets/imgs/侧边栏/电话.png" alt="">
          <p>联系电话</p>
        </el-button>
        <el-button @click="toTop">
          <img src="../assets/imgs/侧边栏/dingbu.png" alt="">
          <p>返回顶部</p>
        </el-button>
    </div>
  </div>
</template> -->

<!-- <script>
export default {
  name: 'Selected',
  data: function() {
    return {

    }
  },
  methods: {
    jump_gxb() {
      location.href = 'https://beian.miit.gov.cn/'
    },
    toTop () {
      document.documentElement.scrollTop = 0
    }
  }
}

</script> -->

<!-- <style scoped>
.title{
  display: flex;
  justify-content: center;
  margin-top: 100px;
  font-size: 35px;
  font-weight: 700;
}

.title_box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title_text{
  width: 80%;
  line-height: 50px;
  margin-top: 50px;
  font-weight: 500;
  font-size: 25px;
  text-indent:2em
}

.title_text span{
  font-weight: 700;
}
</style> -->



<template>
  <div class="bidding-notice">
    <!-- 公告标题（居中加粗） -->
    <div class="notice-title">
      连云港石梁河水库采砂信息化监管平台升级改造项目中标公告
    </div>

    <!-- 发布时间（顶格显示） -->
    <div class="publish-time">
      信息发布时间：2025-11-25
    </div>

    <!-- 空行分隔 -->
    <div class="space"></div>

    <!-- 项目编号 -->
    <div class="info-item">
      <span class="info-label">项目编号：</span>
      <span class="info-content">HHKJ20251110001</span>
    </div>

    <!-- 公告说明 -->
    <div class="notice-explain">
      根据工程招标投标的有关法律、法规、规章和本工程招标文件的规定，连云港石梁河水库采砂信息化监管平台升级改造项目的评标工作已经结束，中标人确定。现将中标结果公示如下：
    </div>

    <!-- 中标核心信息 -->
    <div class="bid-info-list">
      <div class="info-item">
        <span class="info-label">中标人名称：</span>
        <span class="info-content">中国联合网络通信有限公司连云港市分公司</span>
      </div>
      <div class="info-item">
        <span class="info-label">中标价：</span>
        <span class="info-content highlight">701,500元</span>
      </div>
      <div class="info-item">
        <span class="info-label">质量标准：</span>
        <span class="info-content">合格</span>
      </div>
      <div class="info-item">
        <span class="info-label">招标人：</span>
        <span class="info-content">江苏海宏智能科技有限公司</span>
      </div>
      <div class="info-item">
        <span class="info-label">公示日期：</span>
        <span class="info-content">2025-11-25</span>
      </div>
    </div>

    <!-- 空行分隔 -->
    <div class="space"></div>

    <!-- 联系方式 -->
    <div class="contact-title">凡对本次公示提出询问，请按以下方式联系：</div>
    <div class="contact-list">
      <div class="contact-item">
        <span class="contact-label">1. 招标人信息</span>
        <div class="contact-details">
          <div class="detail-item"><span class="detail-label">单位名称：</span>江苏海宏智能科技有限公司</div>
          <div class="detail-item"><span class="detail-label">单位地址：</span>连云港经济技术开发区黄海大道58号</div>
          <div class="detail-item"><span class="detail-label">联系人：</span>陈经理</div>
          <div class="detail-item"><span class="detail-label">联系电话：</span><span class="tel">15602484896</span></div>
        </div>
      </div>
      <div class="contact-item">
        <span class="contact-label">2. 项目联系方式</span>
        <div class="contact-details">
          <div class="detail-item"><span class="detail-label">联系人：</span>陈经理</div>
          <div class="detail-item"><span class="detail-label">联系电话：</span><span class="tel">15602484896</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WinningBidNoticeDocStyle',
  components: {}
}
</script>

<style scoped>
/* 整体容器 - 模拟Word文档纸张质感 */
.bidding-notice {
  width: 100%;
  max-width: 900px;
  margin: 3rem auto;
  padding: 3rem 4rem;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", "SimSun", Arial, sans-serif;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  /* 模拟纸张纹理 */
  background-image: linear-gradient(0deg, rgba(0,0,0,0.01) 1px, transparent 1px);
  background-size: 100% 1.8em;
}

/* 公告标题 - 增强视觉层级 */
.notice-title {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
  color: #1a1a1a;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #e0e0e0;
}

/* 发布时间 - 轻微弱化但保持清晰 */
.publish-time {
  font-size: 16px;
  color: #666;
  margin-bottom: 1rem;
  font-style: italic;
}

/* 空行分隔 - 精准控制间距 */
.space {
  height: 1rem;
}

/* 普通信息项 - 优化对齐和视觉区分 */
.info-item {
  margin-bottom: 1rem;
}
.info-label {
  display: inline-block;
  width: 120px;
  font-weight: 600;
  color: #204982; /* 深蓝色更正式 */
}
.info-content {
  color: #333;
  transition: color 0.2s;
}
/* 高亮关键信息（中标价） */
.highlight {
  color: #d63333;
  font-weight: 600;
}

/* 公告说明 - 优化段落排版 */
.notice-explain {
  text-indent: 2em;
  margin: 1.8rem 0;
  color: #444;
  line-height: 1.9;
}

/* 中标信息列表 - 增加轻微背景区分 */
.bid-info-list {
  margin: 2rem 0;
  padding: 1rem 1.5rem;
  background-color: #f9fbff;
  border-radius: 4px;
  border-left: 3px solid #204982;
}

/* 联系方式标题 */
.contact-title {
  font-weight: 600;
  color: #1a1a1a;
  margin: 2.5rem 0 1.2rem;
  font-size: 17px;
}

/* 联系方式列表 - 优化层级和间距 */
.contact-list {
  margin-left: 0.5rem;
}
.contact-item {
  margin-bottom: 1.8rem;
}
.contact-label {
  font-weight: 600;
  color: #204982;
  display: block;
  margin-bottom: 0.8rem;
  font-size: 16px;
}
.contact-details {
  margin-left: 1.5rem;
}
.detail-item {
  margin-bottom: 0.7rem;
}
.detail-label {
  display: inline-block;
  width: 80px;
  font-weight: 500;
  color: #555;
}

/* 电话号码高亮 */
.tel {
  color: #204982;
  font-weight: 600;
}

/* 悬停效果 - 增强交互体验 */
.info-content:hover {
  color: #204982;
}
.tel:hover {
  color: #d63333;
}

/* 响应式适配 - 移动端优化 */
@media (max-width: 768px) {
  .bidding-notice {
    padding: 2rem 1.5rem;
    margin: 1.5rem auto;
    box-shadow: none;
    border-radius: 0;
  }
  .info-label {
    width: 100px;
  }
  .detail-label {
    width: 70px;
  }
  .notice-title {
    font-size: 20px;
  }
  .bid-info-list {
    padding: 0.8rem 1rem;
  }
}

/* 打印样式优化 - 适配纸质输出 */
@media print {
  .bidding-notice {
    box-shadow: none;
    background-image: none;
    padding: 0;
    margin: 0;
  }
  .highlight, .tel {
    color: #000;
  }
  .bid-info-list {
    border: 1px solid #ccc;
    background-color: #fff;
  }
}
</style>
